import { Link } from "react-router-dom";
import type { GameLocale } from "../i18n/types";
import { getMessages } from "../i18n/messages";

export function LanguageSwitcher({ locale }: { locale: GameLocale }) {
  const m = getMessages(locale);
  const isNo = locale === "no";

  return (
    <div className="flex items-center gap-0.5 text-xs font-bold">
      <Link
        to="/"
        className={`px-1.5 py-1 rounded ${!isNo ? "text-gray-900 dark:text-white" : "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"}`}
        aria-current={!isNo ? "true" : undefined}
        aria-label={m.langSwitchAria}
      >
        {m.langSwitchDa}
      </Link>
      <span className="text-gray-300 dark:text-gray-600">|</span>
      <Link
        to="/no"
        className={`px-1.5 py-1 rounded ${isNo ? "text-gray-900 dark:text-white" : "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"}`}
        aria-current={isNo ? "true" : undefined}
        aria-label={m.langSwitchAria}
      >
        {m.langSwitchNo}
      </Link>
    </div>
  );
}
